import './tailwind.css';
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import '../node_modules/swiper/swiper-bundle.min.css';

import { navOpen } from './scripts/mainNav';

// Click Events //

document.addEventListener('click', (e) => {
  if (e.target.closest('.menu-icon')) {
    navOpen();
  }
  if (e.target.closest('[data-mainmenu="close"]')) {
    navOpen();
  }
});

// Lazysizes
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
// polyfills
import 'lazysizes/plugins/respimg/ls.respimg';

if (!('object-fit' in document.createElement('a').style)) {
  require('lazysizes/plugins/object-fit/ls.object-fit');
}
// eof Lazysizes

import { backToTop, catList, mailList } from './scripts/latestIndex';
import {
  headerRules,
  homeBanner,
  homeScrollText,
  brandsScroll,
  homeScrollTextBottom,
  brandsBg,
  logoColour,
} from './scripts/homeAnimations';
import {
  backToBrand,
  brandBanner,
  brandReveal,
  menuColorChange,
} from './scripts/brandPageAnimations';
import { contactAnimation } from './scripts/contactAnimations';
import {
  aboutTopText,
  aboutBottomText,
  meetSquad,
  threeCs,
  aboutTextBottom,
} from './scripts/aboutAnimations';
import { squadAnimations } from './scripts/squadAnimations';
import { listenersAnimations } from './scripts/listenersAnimations';
import { carousels } from './scripts/carousel';
import { toastNotification } from './scripts/toastNotification';
import { jobCount } from './scripts/jobBoard';
import { theLatest } from './scripts/theLatest';
import { squadCarousel } from './scripts/squadCarousel';

// Home Page //

headerRules();
homeBanner();
homeScrollText();
brandsScroll();
homeScrollTextBottom();
brandsBg();
toastNotification();
// logoColour();

// About Page //
aboutTopText();
aboutBottomText();
aboutTextBottom();
// threeCs();
// meetSquad();

// Latest Page //

// initialBuild();
backToTop();
mailList();
catList();

// Brand Page //

menuColorChange();
// brandBanner();
// backToBrand();

brandReveal();

// Contact Page //

contactAnimation();

// Squad Page //

squadAnimations();
squadCarousel();
/* Listeners */

listenersAnimations();

/* Carousel */

carousels();

/**
 * Job Board
 */

jobCount();

/**
 * The Latest
 */

theLatest();
